export default __webpack_public_path__ + "static/media/download-icon.4991946e.svg";